<template>
  <div>
    <template v-if="!getPaymentLumpSum">
      <p class="font-bold mb-1">Choose your payment method</p>
      <p class="text-sm  mb-8">
        We will collect
        <strong v-if="couponIds.length > 0">your monthly premium</strong>
        <strong v-else>{{ getMonthlyTotal | currency(2) }}</strong>
        each month until you cancel the cover by providing 30 days notice.
      </p>
    </template>
    <template v-else>
      <p>By confirming, we will collect <strong>{{ getMonthlyTotal | currency(2) }}</strong> and your card will be debited this amount.</p>
    </template>

    <div class="flex text-base mb-5">
      <div
        :class="{
          'border-b-2 border-blue-500 ': creditCardActive,
        }"
        class="tab-title cursor-pointer px-2 pb-2 hover:"
        @click="showCreditCard"
      >
        Credit Card
      </div>
      <div
        v-if="isDirectDebitAllowed"
        :class="{
          'border-b-2 border-blue-500': directDebitActive,
        }"
        class="tab-title cursor-pointer px-2 pb-2 hover:"
        @click="showDirectDebit"
      >
        Direct Debit
      </div>
    </div>
    <div>
      <Transition name="fade" mode="out-in">
        <CreditCardForm v-if="creditCardActive" />
        <DirectDebitForm v-else-if="directDebitActive" />
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreditCardForm from './CreditCardForm'
import DirectDebitForm from './DirectDebitForm'

export default {
  components: {
    CreditCardForm,
    DirectDebitForm,
  },
  data () {
    return {
      creditCardActive: true,
      directDebitActive: false,
    }
  },
  computed: {
    ...mapGetters(['getMonthlyTotal', 'getSource', 'getPaymentLumpSum', 'couponIds']),
    isDirectDebitAllowed () {
      // Disallow for Appear Here
      return this.getSource !== 'appear-here'
    },
  },
  methods: {
    showCreditCard () {
      this.directDebitActive = false
      this.creditCardActive = true
    },
    showDirectDebit () {
      this.creditCardActive = false
      this.directDebitActive = true
    },
  },
}
</script>

<style>
.tab-title {
  transition: color 0.5s, border-color 0.5s;
}
</style>
